'use client'

import { ICONS } from "@/sites/nucar/Icons"
import { useEffect, useState } from "react"

export default function Icon(props) {
  
  const [icons,setIcons] = useState()
  
  const styles = Object.assign({ display: 'inline-block',lineHeight: '0rem', minWidth: '16px', maxWidth: '100%', overflow: 'hidden' }, props.style || {})

  useEffect(() => {
    setIcons(ICONS)
  }, [])
  
  if (icons) {
    return <i style={styles}>{ icons[props.name] }</i>
  } else {
    return <></>
  }
  
}

